import React from "react";
import { Layers, CheckCircle2, Building2, Star } from "lucide-react";

function KpiCard({ icon: Icon, title, value, sub, accent, testid }) {
  return (
    <div data-testid={testid}
      className="bg-white rounded-xl border border-slate-200 p-4 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-center gap-2 mb-2">
        <span className="w-8 h-8 rounded-lg flex items-center justify-center"
          style={{ background: `${accent}1A`, color: accent }}>
          <Icon className="w-4 h-4" />
        </span>
        <span className="text-xs font-semibold text-slate-500 leading-tight">{title}</span>
      </div>
      <div className="font-heading text-3xl font-extrabold text-slate-900 tracking-tight">
        {value}
      </div>
      {sub && <div className="text-[11px] text-slate-400 mt-0.5">{sub}</div>}
    </div>
  );
}

export default function KpiCards({ summary }) {
  if (!summary) return null;
  const enc = summary.encuesta;
  const sat = enc && enc.overall != null ? enc.overall.toFixed(1) : "N/D";

  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3">
      <KpiCard testid="kpi-total" icon={Layers} title="Total de Registros"
        value={summary.total.toLocaleString("es-MX")}
        sub={`${summary.actividades_count} obras · ${summary.rac_count} reportes`} accent="#C03C54" />
      <KpiCard testid="kpi-atendidos" icon={CheckCircle2} title="Atendidos"
        value={summary.atendidos.toLocaleString("es-MX")} sub="Casos concluidos" accent="#16A34A" />
      <KpiCard testid="kpi-unidades" icon={Building2} title="Unidades Involucradas"
        value={summary.unidades_count} sub="Dependencias" accent="#C17A5A" />
      <KpiCard testid="kpi-satisfaccion" icon={Star} title="Satisfacción Ciudadana"
        value={sat === "N/D" ? sat : `${sat}`} sub="Promedio Encuestas (0-10)" accent="#5A524A" />
    </div>
  );
}
